export default [
  {
    path: '/role',
    name: 'list-role',
    component: () => import('@/views/role/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.rolePermission',
      resource: 'manage-role',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listRolePermission',
          active: true,
        },
      ],
    },
  },
  {
    path: '/role/create',
    name: 'create-role',
    component: () => import('@/views/role/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.rolePermission',
      navActiveLink: 'list-role',
      resource: 'manage-role',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listRolePermission',
          to: { name: 'list-role' }
        },
        {
          text: 'breadcrumb.createRolePermission',
          active: true,
        },
      ],
    },
  },
  {
    path: '/role/:id/update',
    name: 'update-role',
    component: () => import('@/views/role/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.rolePermission',
      navActiveLink: 'list-role',
      resource: 'manage-role',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listRolePermission',
          to: { name: 'list-role' }
        },
        {
          text: 'breadcrumb.updateRolePermission',
          active: true,
        },
      ],
    },
  },
]
